import service from './mincloud/Service';
import session from './core/Session';

export default class Oxygen{

    static inst = null;

    static get instance() {
        if (!Oxygen.inst) {
            Oxygen.inst = new Oxygen();
            Oxygen.inst.service = service;
            Oxygen.inst.session = session;
        }
        return Oxygen.inst;
    }

    static install(Vue, options) {
        let { clientID, ...restOptions } = options;
        window.BaaS = require('minapp-sdk');
        window.BaaS.init(clientID, restOptions);
        Vue.prototype.$ox = Oxygen.instance;
        Vue.prototype.$ox.eventBus = new Vue();
    }
}
